
import {
    defineComponent,
    PropType,
    onMounted,
    ref,
    getCurrentInstance
} from 'vue'
import set from 'lodash/set'
import BaseInputOutlined from '../../../inputs/BaseInputOutlined.vue'
import CustomActivatorSelect from '../../../inputs/CustomActivatorSelect.vue'
import TimeInput from '../../../inputs/TimeInput.vue'
import { EditedActivation } from '../../../../types/GCB2'
import { checkInputIsIntNumber } from '../../../../utils'
import SpinnerLoader from '../../../SpinnerLoader.vue'
export default defineComponent({
    name: 'BatchModeSettings',
    components: { BaseInputOutlined, CustomActivatorSelect, TimeInput, SpinnerLoader },
    props: {
        value: { type: Object as PropType<EditedActivation>, required: true },
    },
    setup(props, { emit }) {
        const root = getCurrentInstance()!.proxy
        const formInput = (e: any) => {
            const isValid = true
            emit('validation-updated', isValid)
        }
        const clear = () => {
            (root.$refs as any).form.resetValidation()
            props.value.batchModeSettings.default_daily_limit_of_messages_items = batchModeInit.value
        }
        const batchModeInit = ref(null)
        onMounted(() => {
            batchModeInit.value = props.value.batchModeSettings.default_daily_limit_of_messages_items
        })

        return { formInput, checkInputIsIntNumber, set, clear }
    },
})
